export type InternalRole =
  | 'sys_admin'
  | 'general_manager'
  | 'project_lead'
  | 'accountant'
  | 'receptionist'
  | 'data_entry';

export interface MenuItem {
  path: string;
  label: string;
  shortLabel?: string;
  icon: string;
  roles: InternalRole[];
  defaultFor?: InternalRole[];
  primary?: boolean;
}

export const INTERNAL_ROLES: InternalRole[] = [
  'sys_admin',
  'general_manager',
  'project_lead',
  'accountant',
  'receptionist',
  'data_entry',
];

export const MENU_ITEMS: MenuItem[] = [
  {
    path: '/gestion/dashboard',
    label: 'Dashboard',
    shortLabel: 'Inicio',
    icon: 'M3 12l9-9 9 9M5 10v10h5v-6h4v6h5V10',
    roles: INTERNAL_ROLES,
    defaultFor: INTERNAL_ROLES,
    primary: true,
  },
  {
    path: '/gestion/proyectos',
    label: 'Proyectos',
    shortLabel: 'Proyectos',
    icon: 'M3 7h18M3 12h18M3 17h18',
    roles: ['sys_admin', 'general_manager', 'project_lead', 'accountant'],
    defaultFor: ['project_lead'],
    primary: true,
  },
  {
    path: '/gestion/avances',
    label: 'Avances de Obra',
    shortLabel: 'Avances',
    icon: 'M4 19h16M6 15l4-4 3 3 5-5',
    roles: ['sys_admin', 'general_manager', 'project_lead', 'data_entry'],
    primary: true,
  },
  {
    path: '/gestion/avance-obra',
    label: 'Registrar Avance',
    shortLabel: 'Registrar',
    icon: 'M12 5v14M5 12h14',
    roles: ['sys_admin', 'project_lead', 'data_entry'],
  },
  {
    path: '/gestion/clientes',
    label: 'Clientes',
    shortLabel: 'Clientes',
    icon: 'M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2M9 7a4 4 0 100 8 4 4 0 000-8z',
    roles: ['sys_admin', 'general_manager', 'receptionist', 'accountant'],
    defaultFor: ['receptionist'],
    primary: true,
  },
  {
    path: '/gestion/finanzas',
    label: 'Finanzas',
    shortLabel: 'Finanzas',
    icon: 'M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6',
    roles: ['sys_admin', 'general_manager', 'accountant'],
    defaultFor: ['accountant'],
    primary: true,
  },
  {
    path: '/gestion/ordenes-cambio',
    label: 'Órdenes de Cambio',
    shortLabel: 'Cambios',
    icon: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
    roles: ['sys_admin', 'general_manager', 'project_lead', 'accountant'],
  },
  {
    path: '/gestion/documentos',
    label: 'Documentos',
    shortLabel: 'Docs',
    icon: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z M14 2v6h6',
    roles: ['sys_admin', 'general_manager', 'project_lead', 'accountant', 'data_entry'],
  },
  {
    path: '/gestion/mensajes',
    label: 'Mensajes',
    shortLabel: 'Mensajes',
    icon: 'M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z',
    roles: ['sys_admin', 'general_manager', 'project_lead'],
  },
  {
    path: '/gestion/permisos',
    label: 'Permisos',
    shortLabel: 'Permisos',
    icon: 'M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
    roles: ['sys_admin', 'general_manager', 'project_lead', 'data_entry'],
  },
  {
    path: '/gestion/captura-manual',
    label: 'Captura Manual',
    shortLabel: 'Captura',
    icon: 'M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4z',
    roles: ['sys_admin', 'general_manager', 'data_entry'],
    defaultFor: ['data_entry'],
    primary: true,
  },
  {
    path: '/gestion/interno',
    label: 'Interno',
    shortLabel: 'Interno',
    icon: 'M4 4v6h6M20 20v-6h-6M20 4l-6 6M4 20l6-6',
    roles: ['sys_admin', 'general_manager', 'accountant', 'receptionist'],
  },
  {
    path: '/gestion/saldos',
    label: 'Saldos',
    shortLabel: 'Saldos',
    icon: 'M3 3v18h18M7 14l4-4 3 3 5-5',
    roles: ['sys_admin', 'general_manager', 'accountant'],
  },
  {
    path: '/gestion/usuarios',
    label: 'Usuarios',
    shortLabel: 'Usuarios',
    icon: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 7a4 4 0 100 8 4 4 0 000-8z M23 21v-2a4 4 0 00-3-3.87 M16 3.13a4 4 0 010 7.75',
    roles: ['sys_admin'],
    primary: true,
  },
  {
    path: '/gestion/tokens',
    label: 'Tokens',
    shortLabel: 'Tokens',
    icon: 'M12 2l3 7h7l-5.5 4 2 7-6.5-4.5L5.5 20l2-7L2 9h7z',
    roles: ['sys_admin'],
  },
  {
    path: '/gestion/catalogos',
    label: 'Catálogos',
    shortLabel: 'Catálogos',
    icon: 'M4 6h16M4 12h16M4 18h16',
    roles: ['sys_admin'],
  },
  {
    path: '/gestion/bi',
    label: 'Business Intelligence',
    shortLabel: 'BI',
    icon: 'M3 3v18h18M8 17V9m5 8V5m5 12v-6',
    roles: ['sys_admin', 'general_manager'],
  },
  {
    path: '/gestion/configuracion',
    label: 'Configuración',
    shortLabel: 'Ajustes',
    icon: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09a1.65 1.65 0 00-1-1.51 1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09a1.65 1.65 0 001.51-1 1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z',
    roles: INTERNAL_ROLES,
  },
  {
  path: '/gestion/usuarios',
  label: 'Usuarios',
  shortLabel: 'Usuarios',
  icon: 'M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 7a4 4 0 100 8 4 4 0 000-8z M23 21v-2a4 4 0 00-3-3.87 M16 3.13a4 4 0 010 7.75',
  roles: ['sys_admin', 'general_manager'],
  primary: true,
},
{
  path: '/gestion/catalogos',
  label: 'Catálogos',
  shortLabel: 'Catálogos',
  icon: 'M4 6h16M4 12h16M4 18h16',
  roles: ['sys_admin', 'general_manager', 'data_entry'],
},
{
  path: '/gestion/captura-manual',
  label: 'Captura Manual',
  shortLabel: 'Captura',
  icon: 'M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4z',
  roles: ['sys_admin', 'general_manager', 'data_entry'],
  defaultFor: ['data_entry'],
  primary: true,
},
{
  path: '/gestion/configuracion',
  label: 'Configuración',
  shortLabel: 'Ajustes',
  icon: 'M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09a1.65 1.65 0 00-1-1.51 1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09a1.65 1.65 0 001.51-1 1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z',
  roles: ['sys_admin'],
},

];

export function getMenuItemsForRole(role: string | undefined | null): MenuItem[] {
  if (!role) return [];
  return MENU_ITEMS.filter((item) => item.roles.includes(role as InternalRole));
}

export function getPrimaryMenuItemsForRole(role: string | undefined | null): MenuItem[] {
  return getMenuItemsForRole(role).filter((item) => item.primary);
}

export function getSecondaryMenuItemsForRole(role: string | undefined | null): MenuItem[] {
  return getMenuItemsForRole(role).filter((item) => !item.primary);
}

export function getDefaultRouteForRole(role: string | undefined | null): string {
  if (!role) return '/login';
  const explicit = MENU_ITEMS.find((item) =>
    item.defaultFor?.includes(role as InternalRole)
  );
  if (explicit) return explicit.path;
  const fallback = MENU_ITEMS.find((item) => item.roles.includes(role as InternalRole));
  return fallback?.path ?? '/login';
}

export function isRoleAllowedForPath(role: string | undefined | null, path: string): boolean {
  if (!role) return false;
  const normalized = path.split('?')[0];
  const item = MENU_ITEMS.find((m) => normalized.startsWith(m.path));
  if (!item) return true;
  return item.roles.includes(role as InternalRole);
}

export const ROLE_LABELS: Record<InternalRole, string> = {
  sys_admin: 'Administrador del Sistema',
  general_manager: 'Gerente General',
  project_lead: 'Líder de Proyecto',
  accountant: 'Contador',
  receptionist: 'Recepcionista',
  data_entry: 'Capturista de Datos',
};

export function getRoleLabel(role: string | undefined | null): string {
  if (!role) return 'Usuario';
  return ROLE_LABELS[role as InternalRole] ?? role;
}